// extracted by mini-css-extract-plugin
export var Dentists = "index-module--Dentists--8CSvB";
export var activebullet = "index-module--activebullet--8LzAQ";
export var bullet = "index-module--bullet--ratSz";
export var dentist = "index-module--dentist--xucHx";
export var dentistnav = "index-module--dentistnav--St6l3";
export var heading = "index-module--heading--Io9OP";
export var hiddendentist = "index-module--hiddendentist--ThB1X";
export var icon = "index-module--icon--YoKNi";
export var image = "index-module--image--LOVCz";
export var imagecontainer = "index-module--imagecontainer--Ouv2c";
export var linkhover = "index-module--linkhover---8LOL";
export var next = "index-module--next--tf9aI";
export var noimage = "index-module--noimage--3wZGg";
export var previous = "index-module--previous--PnVA-";
export var title = "index-module--title--3M8k1";
export var view = "index-module--view--0bV+b";